import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ConflictModal from './conflict_modal';

import './conflict_modal.scss';

class ConflictModalWrapper extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
    };

    this.onOpenModal = this.onOpenModal.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
  }

  onOpenModal() {
    this.setState({ modalOpen: true });
  }

  onCloseModal() {
    this.setState({ modalOpen: false });
  }

  render() {
    const { children } = this.props;
    const { modalOpen } = this.state;

    return (
      <div className="conflict-modal-wrapper" role="button" tabIndex="0" onClick={this.onOpenModal}>
        {children}
        {modalOpen && <ConflictModal {...this.props} onClose={this.onCloseModal} />}
      </div>
    );
  }
}

ConflictModalWrapper.propTypes = {
  children: PropTypes.node,
  property: PropTypes.shape({}),
};

export default ConflictModalWrapper;
